import { useEffect } from 'react';
import cn from 'classnames';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const TextoP1 = ({ classes, text }) => {
  useEffect(() => {
    const textosP1 = gsap.utils.toArray('.text-p1-js');

    textosP1.forEach((elem) => {
      gsap.fromTo(
        elem,
        {
          autoAlpha: 0,
          y: 10
        },
        {
          scrollTrigger: {
            trigger: elem,
            start: 'top bottom'
            // markers: true
          },
          autoAlpha: 1,
          y: 0,
          delay: 0.5
        }
      );
    });
  }, []);

  return <p className={cn(classes, 'text-p1-js')}>{text}</p>;
};
export default TextoP1;
